export interface LabelValue {
  label: string;
  value: string;
  selected?: boolean;
  hidden?: boolean;
}

export interface MainFilterItem {
  key: string;
  selected: LabelValue;
  options: Array<LabelValue>;
  disabled?: boolean;
  show?: boolean;
  type?: string;
}

export const DOMAIN_FILTERS = [
  { region: 'US', regionText: 'US', device: 'desktop' },
  { region: 'US', regionText: 'US', device: 'mobile' },
  { region: 'NON-US', regionText: 'Non U.S.', device: 'desktop' },
  { region: 'NON-US', regionText: 'Non U.S.', device: 'mobile' },
  { region: 'GLOBAL', regionText: 'Global', device: 'desktop' },
  { region: 'GLOBAL', regionText: 'Global', device: 'mobile' }
];

export const MAIN_FILTER_ITEMS: Array<MainFilterItem> = [
  {
    key: 'region',
    selected: {
      label: 'GLOBAL',
      value: 'GLOBAL'
    },
    options: [
      {
        label: 'GLOBAL',
        value: 'GLOBAL'
      },
      {
        label: 'APAC',
        value: 'APAC'
      },
      {
        label: 'EMEA',
        value: 'EMEA'
      },
      {
        label: 'LATAM',
        value: 'LATAM'
      },
      {
        label: 'North America',
        value: 'NA'
      }
    ]
  },
  {
    key: 'country',
    type: 'dropdown-search',
    selected: {
      label: 'All Countries',
      value: 'GLOBAL'
    },
    options: [
      {
        label: 'All Countries',
        value: 'GLOBAL'
      }
    ]
  },
  {
    key: 'device',
    selected: {
      label: 'Desktop',
      value: 'desktop'
    },
    options: [
      {
        label: 'All Devices',
        value: 'GLOBAL'
      },
      {
        label: 'Desktop',
        value: 'desktop'
      },
      {
        label: 'Mobile',
        value: 'mobile'
      }
    ]
  },
  {
    key: 'month',
    selected: null,
    options: null
  }
];
